import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class LeadsService extends ServiceCRUD {

  private baseUrlService: string;
  public carregando = true;
  
  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }
  
  protected getURL(): string {
    return '';
  }
  
  public getDados(caminho: any, data_inicial?: any, data_final?: any, dealer?: any, status_Lead?: any, cod_evento?: any, 
    modelo_veic?: any, versao_veic?: any, numeroProposta?: any, id_lead?: any, somente_fabrica?: any, id_fabrica?: any, tipo_evento?: any, origem?: any): Observable<any> {

    return this.httpClient.get<any>(`${this.baseUrlService + caminho}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealer', dealer.toString())
        .set('status', status_Lead.toString())
        .set('cod_evento', cod_evento.toString())
        .set('modelo_veic', modelo_veic.toString())
        .set('versao_veic', versao_veic.toString())
        .set('numeroProposta', numeroProposta.toString())
        .set('id_lead', id_lead.toString())
        .set('somente_fabrica', somente_fabrica.toString())
        .set('id_fabrica', id_fabrica.toString())
        .set('tipo_evento', tipo_evento.toString())
        .set('origem', origem.toString())
    });
  }
}